import { createAction, createErrorAction } from '@saucelabs/sl-util-redux';
import { push } from 'connected-react-router';

import * as types from './types';

export const updatePathByTab = (payload) => (
  push(`/team-management/${payload}`)
);

export const updateSettingsPathByTab = (payload) => (
  push(`/team-management/settings/${payload}`)
);

export const toggleLoading = createAction(types.TOGGLE_LOADING);

export const getInitialDataRequest = createAction(types.INITIAL_DATA.REQUEST);
export const getInitialDataSuccess = createAction(types.INITIAL_DATA.SUCCESS);
export const getInitialDataFailure = createErrorAction(types.INITIAL_DATA.FAILURE);

export const getInitialUserTableRequest = createAction(types.INITIAL_USER_TABLE.REQUEST);
export const getInitialUserTableSuccess = createAction(types.INITIAL_USER_TABLE.SUCCESS);
export const getInitialUserTableFailure = createErrorAction(types.INITIAL_USER_TABLE.FAILURE);
